// extracted by mini-css-extract-plugin
module.exports = {"segmented":"Segmented_segmented__8j31a"};